export const TAB_ACTIVE_USER_CHANNEL = 'impersonation-active-user';
